import { ActionTree, GetterTree, MutationTree, Module } from 'vuex'
import BuyerCampaignTrafficControlAPI from '@/api/buyer-campaign-traffic-control.api'
import {
  CampaignTrafficControlState,
  AllowedSellersResponse
} from '@/store/campaign-traffic-control'

const state: CampaignTrafficControlState = {
  // Structure: { [campaignId]: AllowedSellersResponse }
  campaignAllowedSellers: {}
}

const getters: GetterTree<CampaignTrafficControlState, any> = {
  getAllowedSellers: (state) => (campaignId: string): AllowedSellersResponse | null => {
    return state.campaignAllowedSellers[campaignId] || null
  }
}

interface FetchAllowedSellersPayload {
  campaignId: string
}

interface UpdateAllowedSellersPayload {
  campaignId: string
  sellerIds: string[]
}

const actions: ActionTree<CampaignTrafficControlState, any> = {
  /**
   * Fetch allowed sellers for a campaign
   */
  async fetchAllowedSellers(
    { commit },
    { campaignId }: FetchAllowedSellersPayload
  ): Promise<AllowedSellersResponse> {
    const response = await BuyerCampaignTrafficControlAPI.getAllowedSellers(campaignId)

    const allowedSellersData: AllowedSellersResponse = response.data

    commit('SET_ALLOWED_SELLERS', {
      campaignId,
      data: allowedSellersData
    })

    return allowedSellersData
  },

  /**
   * Update allowed sellers for a campaign
   */
  async updateAllowedSellers(
    { commit },
    { campaignId, sellerIds }: UpdateAllowedSellersPayload
  ): Promise<AllowedSellersResponse> {
    await BuyerCampaignTrafficControlAPI.setAllowedSellers(
      campaignId,
      sellerIds
    )

    const response = await BuyerCampaignTrafficControlAPI.getAllowedSellers(campaignId)
    const allowedSellersData: AllowedSellersResponse = response.data

    commit('SET_ALLOWED_SELLERS', {
      campaignId,
      data: allowedSellersData
    })

    return allowedSellersData
  }
}

interface SetAllowedSellersPayload {
  campaignId: string
  data: AllowedSellersResponse
}

const mutations: MutationTree<CampaignTrafficControlState> = {
  /**
   * Set allowed sellers for a campaign
   */
  SET_ALLOWED_SELLERS(state, { campaignId, data }: SetAllowedSellersPayload): void {
    state.campaignAllowedSellers = {
      ...state.campaignAllowedSellers,
      [campaignId]: data
    }
  }
}

const campaignTrafficControlModule: Module<CampaignTrafficControlState, any> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}

export default campaignTrafficControlModule
